module.exports = __webpack_public_path__ + "img/footer-logo.f26ee7bb.svg";